export default __webpack_public_path__ + "images/ac94c39fcf077b8bc75d8b20a19e415e-pyxir-greeting-2x.en.png";